import { orchestrator } from 'satcheljs';
import { updateCalendarDisplayOrder } from '../actions/updateCalendarDisplayOrder';
import updateCalendarDisplayOrderRESTService from '../services/updateCalendarDisplayOrderRESTService';
import { getCalendarEntryByCalendarId, updateCalendarEntry } from 'owa-calendar-cache';
import { refreshCalendarStoreWithCalendarCacheData } from 'owa-calendar-surface-select-calendar';
import { getCalendarDisplayOrderData } from '../utils/getDisplayOrderData';
import { instantReorderCalendars } from '../utils/instantReorderCalendars';
import { trace } from 'owa-trace';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';

/**
 * The action worker which handles updating of the calendar display order.
 */
export default orchestrator(updateCalendarDisplayOrder, async actionMessage => {
    const {
        userIdentity,
        draggedCalendarId,
        prevCalendarId,
        nextCalendarId,
        destParentGroupId,
    } = actionMessage;

    const dataPoint = returnTopExecutingActionDatapoint();

    try {
        if (!destParentGroupId || !userIdentity || !draggedCalendarId) {
            return;
        }

        const draggedCalendarEntry = getCalendarEntryByCalendarId(draggedCalendarId);
        const currParentGroupId = draggedCalendarEntry.ParentGroupId;

        const displayOrderData = getCalendarDisplayOrderData(
            draggedCalendarId,
            prevCalendarId,
            nextCalendarId,
            destParentGroupId,
            userIdentity
        );

        instantReorderCalendars(
            userIdentity,
            draggedCalendarId,
            prevCalendarId,
            nextCalendarId,
            displayOrderData.CalendarGroupId ? destParentGroupId : undefined
        );

        // Mark user perceived time here when the display order is updated locally.
        if (dataPoint) {
            dataPoint.markUserPerceivedTime();
        }

        // Send POST request to update the order
        const updateResponse = await updateCalendarDisplayOrderRESTService(
            userIdentity,
            draggedCalendarId,
            displayOrderData
        );

        if (updateResponse) {
            // Update the displayOrder of the dragged calendar
            updateCalendarEntry(draggedCalendarEntry.calendarId.itemId, {
                DisplayOrder: updateResponse.DisplayOrder,
            });
        } else {
            // Revert parentGroupId and refresh store calendars to restore original order
            if (displayOrderData.CalendarGroupId) {
                updateCalendarEntry(draggedCalendarEntry.calendarId.itemId, {
                    ParentGroupId: currParentGroupId,
                });
            }
            refreshCalendarStoreWithCalendarCacheData(userIdentity);
        }
    } catch (error) {
        trace.warn('Unable to update calendar display order.');
        return;
    }
});
